/**
 * earningsApi.js
 * 
 * Frontend API calls for Earnings
 */

import axios from "axios";

// ✅ Create axios instance with base URL
const API_URL = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/earnings`,
});

// ✅ Get auth header
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

/**
 * 📊 Get earnings summary (Today, Week, Month, Commission)
 */
export async function getEarningsSummary(commissionRate = 20) {
  try {
    const res = await API_URL.get(`/summary?commissionRate=${commissionRate}`, getAuthHeader());
    return res.data;
  } catch (err) {
    console.error("getEarningsSummary error:", err);
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

/**
 * 📈 Get weekly chart data (Last 7 days)
 */
export async function getWeeklyChartData() {
  try {
    const res = await API_URL.get("/weekly-chart", getAuthHeader());
    return res.data;
  } catch (err) {
    console.error("getWeeklyChartData error:", err);
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

/**
 * 📈 Get monthly chart data (Last 12 months)
 */
export async function getMonthlyChartData() {
  try {
    const res = await API_URL.get("/monthly-chart", getAuthHeader());
    return res.data;
  } catch (err) {
    console.error("getMonthlyChartData error:", err);
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

/**
 * 💰 Get driver payouts for a specific date
 */
export async function getDriverPayouts(date = null, commissionRate = 20) {
  try {
    const params = [`commissionRate=${commissionRate}`];
    if (date) params.push(`date=${date}`);
    const queryString = `?${params.join("&")}`;
    
    const res = await API_URL.get(`/driver-payouts${queryString}`, getAuthHeader());
    return res.data;
  } catch (err) {
    console.error("getDriverPayouts error:", err);
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

/**
 * 📅 Get earnings by custom date range
 */
export async function getEarningsByDateRange(startDate, endDate, commissionRate = 20) {
  try {
    const params = [`startDate=${startDate}`, `endDate=${endDate}`, `commissionRate=${commissionRate}`];
    const queryString = `?${params.join("&")}`;
    
    const res = await API_URL.get(`/date-range${queryString}`, getAuthHeader());
    return res.data;
  } catch (err) {
    console.error("getEarningsByDateRange error:", err);
    return { success: false, error: err.response?.data?.error || err.message };
  }
}
